import React, { Component } from 'react';
import { DISABLE_OPACITY } from '@com-m/tool-bar-m/toolbar-item-hoc';
import { addPanelHandlerMap } from './add-items-handler';
import style from './index.css';

export interface IItemData {
    id: string;
    icon: string;
    tipMsg: string;
    disabled?: boolean;
    clickHandler?: () => {};
}
interface IProps {
    itemData: IItemData;
}
export default class Item extends Component<IProps> {
    public render() {
        const { itemData } = this.props;
        if (!itemData.id) {
            return <div className={style['add-item-blank']}/>;
        }
        return <div className={style['add-item-wrapper']} style={{ opacity: itemData.disabled ? DISABLE_OPACITY : 1 }} >
            <div
                className={style['add-item']}
                onClick={this.onclick}
            >
                <img className={style['add-item-img']} src={itemData.icon} />
            </div>
            <div className={style['add-item-tip']}>{itemData.tipMsg}</div>
        </div>;
    }

    private onclick = () => {
        const { itemData } = this.props;
        if (itemData.disabled) {
            return;
        }
        if (itemData.clickHandler) {
            // 优先使用外部传递的回调
            itemData.clickHandler();
        } else {
            addPanelHandlerMap[itemData.id]?.();
        }
    };
}
